module.exports = __webpack_public_path__ + "img/avatar_random_15.43788635.png";